export interface Organization {
  name: string;
  id: string;
  district: { name: string; id: string };
}

export const uniqueMap = <T, K>(arr: T[], cb: (i: T) => K): K[] => {
  const map = new Map<K, K>();
  arr.forEach((item) => {
    map.set(cb(item), cb(item));
  });
  return Array.from(map.values());
};
